var _rect, _g, _rect2, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgUploadFeaturedIconOver(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 46,
    height: 47,
    viewBox: "0 0 46 47",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 3,
    y: 3.5,
    width: 40,
    height: 40,
    rx: 20,
    fill: "#FFBAA4"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_526_30413)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M26.3335 26.8332L23.0002 23.4999M23.0002 23.4999L19.6669 26.8332M23.0002 23.4999V30.9999M29.9919 28.8249C30.8047 28.3818 31.4467 27.6806 31.8168 26.8321C32.1868 25.9835 32.2637 25.0359 32.0354 24.1388C31.807 23.2417 31.2865 22.4462 30.5558 21.8778C29.8251 21.3094 28.9259 21.0005 28.0002 20.9999H26.9502C26.698 20.0243 26.2278 19.1185 25.5752 18.3507C24.9225 17.5829 24.1042 16.9731 23.182 16.5671C22.2597 16.161 21.2573 15.9694 20.2503 16.0065C19.2433 16.0436 18.2578 16.3085 17.3679 16.7813C16.4779 17.2541 15.7068 17.9225 15.1124 18.7362C14.518 19.55 14.1158 20.4879 13.936 21.4794C13.7563 22.4709 13.8036 23.4903 14.0746 24.461C14.3455 25.4316 14.8329 26.3281 15.5002 27.0832",
    stroke: "#475467",
    strokeWidth: 1.66667,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 3,
    y: 3.5,
    width: 40,
    height: 40,
    rx: 20,
    stroke: "#FFFBFA",
    strokeWidth: 6
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_526_30413"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white",
    transform: "translate(13 13.5)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgUploadFeaturedIconOver);
export default __webpack_public_path__ + "static/media/UploadFeaturedIcon-Over.0ea4341cc16e1359ba079ada95d89c2b.svg";
export { ForwardRef as ReactComponent };